import { makeStyles } from '@mui/styles';

const useSiteFooterStyle = makeStyles({
  root: {
    textAlign: 'center',
    width: '50%',
    bottom: 0,
    margin: 'auto',
  },
  rootMobile: {
    width: '100%',
  },
  footer: {
    zIndex: '100 !important',
    color: 'inherit !important',
  },
});

export default useSiteFooterStyle;
